// assets/ppl-mega-menu.js
// Fancy mega-menu behavior (supports MULTIPLE mega menus on the same page)
// - Hover/focus opens
// - Mouseleave/focusout closes with a short delay
// - Click outside / ESC closes
// - Adds "is-closing" class so CSS can animate closing before removing [open]
(function () {
  const MQ = window.matchMedia('(min-width: 990px)');
  if (!MQ.matches) return;

  const roots = Array.from(document.querySelectorAll('.ppl-mm'));
  if (!roots.length) return;

  function initRoot(root) {
    const detailsList = Array.from(root.querySelectorAll('.ppl-mm__details'));
    if (!detailsList.length) return;

    let closeTimer = null;

    function clearCloseTimer() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function closeWithAnim(detailsEl) {
      if (!detailsEl || !detailsEl.hasAttribute('open')) return;

      // Avoid stacking close animations
      if (detailsEl.classList.contains('is-closing')) return;

      detailsEl.classList.add('is-closing');

      // Wait for CSS transition, then actually close
      window.setTimeout(() => {
        detailsEl.removeAttribute('open');
        detailsEl.classList.remove('is-closing');
      }, 220);
    }

    function closeAll(except) {
      detailsList.forEach((d) => {
        if (d !== except) closeWithAnim(d);
      });
    }

    function closeLater(detailsEl) {
      clearCloseTimer();
      closeTimer = setTimeout(() => {
        closeWithAnim(detailsEl);
      }, 180);
    }

    detailsList.forEach((d) => {
      const summary = d.querySelector('summary');
      const panel = d.querySelector('.ppl-mm__panel');
      if (!summary) return;

      function open() {
        clearCloseTimer();

        // If it was closing, cancel that state
        d.classList.remove('is-closing');

        // Only one open per root
        closeAll(d);

        d.setAttribute('open', 'open');
      }

      // Hover open
      summary.addEventListener('mouseenter', open);

      // Keyboard open
      summary.addEventListener('focus', open);

      // Keep open when cursor is inside the panel
      if (panel) panel.addEventListener('mouseenter', open);

      // Close when leaving the whole details area
      d.addEventListener('mouseleave', () => closeLater(d));

      // Close when focus leaves this details component
      d.addEventListener('focusout', (e) => {
        if (!d.contains(e.relatedTarget)) closeLater(d);
      });

      // Click behavior:
      // - allow click-to-open
      // - close others when opened via click
      summary.addEventListener('click', () => {
        window.setTimeout(() => {
          if (d.hasAttribute('open')) {
            d.classList.remove('is-closing');
            closeAll(d);
          }
        }, 0);
      });
    });

    // Click outside closes only this root
    document.addEventListener('click', (e) => {
      if (!root.contains(e.target)) closeAll(null);
    });

    // Escape closes
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      closeAll(null);
    });
  }

  roots.forEach(initRoot);
})();
